<template>
  <div class="new-build__root">
    <ba-header :activeModule="activeModule"></ba-header>

    <div class="u-pt4"></div>
    <div class="row u-p4 main-content" v-loading="isBranchesLoading">
      <div class="el-card u-mb4">
        <h4 class="c-heading__section u-mb4">Run new build</h4>
        <el-select v-if="!isBranchesLoading" v-model="selected_branch" @change="branchWillChange" placeholder="Select branch" filterable>
          <el-option
                  v-for="item in available_branches"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
          </el-option>
        </el-select>

        <div v-loading="isBranchDetailsLoading">

        </div>
        <div v-if="!isBranchDetailsLoading && selected_branch_details">
          <div>{{selected_branch_details.user}}</div>
          <div>{{selected_branch_details.message}}</div>
          <div>{{selected_branch_details.commit_date | moment('YYYY-MM-DD HH:mm')}} ({{selected_branch_details.commit_date |  moment("from", "now")}})</div>

        </div>
        <el-checkbox v-model="useCustomCommitId" class="u-mb4 u-mt4">Use custom commitId</el-checkbox>
        <div v-if="useCustomCommitId" class="col-12 col-sm-6  ">
          <el-input placeholder="Commit hash in GIT" v-model="commitId"></el-input>
        </div>
        <div class="col-12 u-mt4">
          <div class="u-mb2 u-text--sm">Build comment:</div>
          <el-input  placeholder="Build comment..." v-model="buildComment"></el-input>
        </div>
        <div class="col-12" v-if="mode === 'desktop'">
          <el-checkbox v-model="deployWhenCompleted" class="u-mb4 u-mt4">Automatically deploy when completed</el-checkbox>
          <el-checkbox v-if="deployWhenCompleted" v-model="runSmokeTests" class="u-mb4 u-mt4">Automatically run smoke tests when completed</el-checkbox>
        </div>
        <div class="col-12" v-if="mode === 'mobile'">
          <el-checkbox v-model="publishToTestFlightWhenCompleted" class="u-mb4 u-mt4">Automatically send to Bitrise/TestFlight when completed</el-checkbox>
        </div>
      </div>
      <div class="col-12 col-sm-6 u-mt4">
        <el-button v-if="!loading" @click="queueBuild()" class="build-button el-button--primary">Build for {{mode | capitalize}}</el-button>
        <el-button v-if="loading" :disabled="true" class="build-button--disabled">Please wait...</el-button>
      </div>
    </div>



  </div>
</template>

<script>
import axios from 'axios'
import BaHeader from '@/components/header.component'
import config from '@/config'
import ElCheckbox from 'element-ui/packages/checkbox/src/checkbox'

export default {
  components: {
    ElCheckbox,
    BaHeader},
  name: 'ba-new-build',
  data () {
    this.load_available_branches()
    return {
      companyId: this.$route.params.companyId,
      loading: false,
      commitId: '',
      selected_branch: null,
      available_branches: [],
      selected_branch_details: null,
      isBranchesLoading: true,
      isBranchDetailsLoading: false,
      useCustomCommitId: false,
      deployWhenCompleted: true,
      runSmokeTests: false,
      publishToTestFlightWhenCompleted: false,
      buildComment: '',
    }
  },
  computed: {
    mode () {
      return this.$route.query.mode
    },
    activeModule () {
      return this.mode === 'desktop' ? 'Web Builds' : 'Mobile Builds'
    }
  },
  methods: {
    async load_available_branches () {
      this.isBranchesLoading = true
      let response = await axios.get(`${config.url}/new-build/branches/`)
      this.selected_branch = response.data.default_branch
      this.available_branches = response.data.branches

      this.branchWillChange(this.selected_branch)
      this.isBranchesLoading = false
    },
    async branchWillChange (e) {
      let selected = this.available_branches.find((_) => _.name === e)
      this.useCustomCommitId = true
      this.commitId = selected.sha
      this.buildComment = selected.name
      this.isBranchDetailsLoading = true

      let response
      try {
        response = await axios.get(selected.link)
      } finally {
        this.isBranchDetailsLoading = false
      }

      if (!response) { return }

      this.selected_branch_details = response.data
    },
    queueBuild () {
      this.loading = true

      let commitId = this.useCustomCommitId ? this.commitId : ''
      axios.post(
        `${config.url}/company/${this.companyId}/build-${this.mode}-app/`,
        { commit_id: commitId,
          build_comment: this.buildComment,
          deploy_when_completed: this.deployWhenCompleted,
          publish_to_test_flight: this.publishToTestFlightWhenCompleted,
          run_smoke_tests_when_completed: this.runSmokeTests,
        })
        .then(response => {
          this.$notify({
            title: 'Success',
            message: 'Build has been queued...',
            type: 'success'
          })
          this.$router.back()
        })
        .catch(response => {
          this.$notify.error({
            title: 'Error',
            message: 'Failed to queue build at this time',
          })
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>

</style>